import axios from '@/libs/axios'
import { handleCatch } from '@/utils'
import { ApiCode } from '@/const/api'
import { baseAttr } from '@/store/student-class'

export default {
  // eslint-disable-next-line consistent-return
  async downloadExportExamGraduationClass(params) {
    try {
      const response = await axios({
        method: 'get',
        url: 'uni/hbhReports/reportStudentExamGraduationHbh',
        responseType: 'blob',
        params,
      })
      if (response.status.toString() === '200') {
        return response.data
      }
      return null
    } catch (e) {
      handleCatch(e)
    }
  },

  async getInfoStudentCgpa(params) {
    try {
      const response = await axios.get('uni/studentClasses/getInfoStudentCgpa', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
      return {}
    } catch (e) {
      handleCatch(e)
    }
  },

  async downloadExportTranscript(params) {
    try {
      const response = await axios({
        method: 'get',
        url: 'uni/studentClasses/downloadExportTranscript',
        responseType: 'blob',
        params,
      })
      if (response.status.toString() === '200') {
        return response.data
      }
      return null
    } catch (e) {
      handleCatch(e)
    }
  },

  async downloadExportTranscriptsZipForClass(params) {
    try {
      const response = await axios({
        method: 'get',
        url: 'uni/tnhReports/downloadExportTranscriptsZipForClass',
        responseType: 'blob',
        params,
      })
      if (response.status.toString() === '200') {
        return response.data
      }
      return null
    } catch (e) {
      handleCatch(e)
    }
  },

  async downloadZip(params) {
    try {
      const response = await axios.get('uni/tnhReports/reportStudentManagementRegisterForClass', { params, responseType: 'blob' })
      if (response.status === 200) {
        return response.data
      }
      return null
    } catch (e) {
      handleCatch(e)
    }
  },
}
